import React, { useEffect, useRef } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import Normal from "./normal";
import Checkbox from "./checkbox";
import Combobox from "./combobox";
import PushButton from "./pushbutton";
import ToggleButton from "./togglebutton";
import Time from "./time";
import Ipaddress from "./ipaddress";
import Server from "./server";
import Siteid from "./siteid";
import Password from "./password";
import Phone from "./phone";
import Masonry from "masonry-layout";

const ParametersView = (props) => {
  const mac = mqtt_topics.choosenmac;
  const [state, setState] = useStateIfMounted({
    How_to_display_json: "",
  });
  let categoryid = "Htd " + props.viewId.replace("_", " ");

  // requestdata() used to attach an ANONYMOUS "message" listener on every call.
  // The effect below that calls it has no dependency array, so it runs after
  // every render — meaning a new listener was added on every render and none of
  // them could ever be removed (the unmount cleanup called
  // removeListener("message") with no function, which throws).
  //
  // Instead the listener is created once and kept in a ref so it can be removed
  // by reference on unmount. requestdata() is called with more than one
  // datatype (the "Htd ..." category topic and the plain view topic), so the
  // handler matches against the set of topics subscribed so far rather than a
  // single captured value — preserving the previous behaviour where each
  // attached closure responded to its own topic.
  const targettopicsRef = useRef(new Set());
  const messageHandlerRef = useRef(null);

  function requestdata(datatype) {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      datatype
    );
    mqtt_topics.busy_Requesting_Data = false;
    let targettopic = mqtt_topics.fixed_topic_part + mac + "/" + datatype;
    targettopicsRef.current.add(targettopic);
    props.mqttClient.subscribe(targettopic);

    if (!messageHandlerRef.current) {
      messageHandlerRef.current = function handleMqttMessage(topic, message) {
        if (targettopicsRef.current.has(topic)) {
          try {
            message = JSON.parse(message.toString());
            setState({
              How_to_display_json: message,
            });
          } catch (error) {
            //console.log(message);
          }
        }
      };
      props.mqttClient.on("message", messageHandlerRef.current);
    }
  }

  function processHowToDisplay(htd) {
    let items = [];
    let li = [];
    let failed_torender_display = (
      <div className="col">
        <center>
          <p>
            Failed to render display :(
            <br />
          </p>
        </center>
      </div>
    );
    if (htd != "") {
      try {
        let sub_category_name;
        let sub_categories_elements;
        let sub_category_elementname;
        let sub_category_inputtype;
        let sub_category_min;
        let sub_category_max;
        let sub_category_unit;
        let sub_category_step;
        let commonvalues;
        let commonstep;
        let common_unit;
        let common_min;
        let common_max;
        let common_inputtype;
        let parameters_category = htd.parameters_category;
        //let category_auth_level = htd.categ_auth_level;
        let sub_category_common_acc;
        let sub_category_common_vis;
        let sub_category_acc;
        let val_auth_level;
        for (
          let categoryindex = 0;
          categoryindex < htd.sub_categories.length;
          categoryindex++
        ) {
          sub_category_name = htd.sub_categories[categoryindex].subc_name;
          let notauthorizeddisplay = (
            <div className="col" key={sub_category_name + "_authorityIssue"}>
              <center>
                <strong>
                  Not authorized parameter category
                  <br />
                </strong>
              </center>
            </div>
          );
          //checking category authentication
          // if ((props.authlevel) >= category_auth_level) {
          sub_category_common_acc = htd.sub_categories[categoryindex].sc_acc;
          sub_category_common_vis = htd.sub_categories[categoryindex].sc_vis;
          if (
            props.authlevel >= sub_category_common_vis ||
            sub_category_common_vis == undefined
          ) {
            sub_categories_elements =
              htd.sub_categories[categoryindex].elements_array;
            commonvalues = htd.sub_categories[categoryindex].values;
            commonstep = htd.sub_categories[categoryindex].step;
            common_min = htd.sub_categories[categoryindex].min;
            common_max = htd.sub_categories[categoryindex].max;
            common_unit = htd.sub_categories[categoryindex].unit;
            common_inputtype = htd.sub_categories[categoryindex].input_type;
            //card-header
            items.push(
              <div
                className="col"
                key={sub_category_name + "_" + sub_categories_elements + "_sc"}
              >
                <h5>
                  <span className="badge badge-secondary">
                    {sub_category_name}
                  </span>
                </h5>
              </div>
            );
            items.push(
              <div
                className="container grid-container"
                key={sub_category_name + "_" + sub_categories_elements + "_con"}
              >
                <div className="row" key={sub_category_name + "_ph"}>
                  {sub_categories_elements.map((element) => {
                    sub_category_elementname = element.name;
                    sub_category_inputtype =
                      element.input_type == undefined
                        ? common_inputtype
                        : element.input_type;
                    sub_category_min =
                      element.min == undefined ? common_min : element.min;
                    sub_category_max =
                      element.max == undefined ? common_max : element.max;
                    sub_category_unit =
                      element.unit == undefined ? common_unit : element.unit;
                    sub_category_step =
                      element.step == undefined ? commonstep : element.step;
                    val_auth_level =
                      element.val_auth_level == undefined
                        ? 2
                        : element.val_auth_level;
                    sub_category_acc =
                      element.sc_acc == undefined
                        ? sub_category_common_acc
                        : element.sc_acc;

                    li = [];

                    switch (sub_category_inputtype.toLowerCase()) {
                      case "normal":
                        {
                          li.push(
                            <Normal
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              startedToListen={false}
                              unit={sub_category_unit}
                              min={sub_category_min}
                              max={sub_category_max}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              step={sub_category_step}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "phone":
                        {
                          li.push(
                            <Phone
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              startedToListen={false}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "checkbox":
                        {
                          li.push(
                            <Checkbox
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              startedToListen={false}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "combobox":
                        {
                          li.push(
                            <Combobox
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              values={
                                element.values != undefined
                                  ? element.values
                                  : commonvalues
                              }
                              startedToListen={false}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "pushbutton":
                        {
                          li.push(
                            <PushButton
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "togglebutton":
                        {
                          li.push(
                            <ToggleButton
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "time":
                        {
                          li.push(
                            <Time
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                          li.push(
                            <div
                              className="w-25"
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_extraspace"
                              }
                            ></div>
                          );
                        }
                        break;
                      case "ip":
                        {
                          li.push(
                            <Ipaddress
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "server":
                        {
                          li.push(
                            <Server
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "siteid":
                        {
                          li.push(
                            <Siteid
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      case "password":
                        {
                          li.push(
                            <Password
                              key={
                                parameters_category.replace(" ", "_") +
                                "_" +
                                sub_category_name.replace(" ", "_") +
                                "_" +
                                sub_category_elementname.replace(" ", "_") +
                                "_div"
                              }
                              title={sub_category_elementname}
                              category={parameters_category}
                              subcategory={sub_category_name}
                              mqttClient={props.mqttClient}
                              acc={props.authlevel >= sub_category_acc}
                            />
                          );
                        }
                        break;
                      default: {
                        li.push(
                          <div
                            className="col"
                            key={
                              parameters_category.replace(" ", "_") +
                              "_" +
                              sub_category_elementname.replace(" ", "_") +
                              "_div"
                            }
                          >
                            <center>
                              <p>
                                Unhandled display type :(
                                <br />
                              </p>
                            </center>
                          </div>
                        );
                      }
                    }
                    //}
                    return li;
                  })}
                </div>
              </div>
            );
          }
          /*} else {
            items.push(notauthorizeddisplay);
            break;
          }*/
        }
      } catch (Exception) {
        //console.log(Exception);
        items = [];
        items.push(failed_torender_display);
      }
    } else {
      items = [];
      items.push(failed_torender_display);
    }
    return items;
  }

  useEffect(() => {
    if (state.How_to_display_json == "") {
      if (!mqtt_topics.busy_Requesting_Data) {
        requestdata(categoryid);
      } else {
        setTimeout(function () {
          requestdata(categoryid);
        }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
      }
    }
  }, []); //state.How_to_display_json

  useEffect(() => {
    // code to run after render goes here
    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata(props.viewId.replace("_", " "));
    } else {
      setTimeout(function () {
        requestdata(props.viewId.replace("_", " "));
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  });

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(
        mqtt_topics.fixed_topic_part + mac + "/" + categoryid
      );
      // Was removeListener("message") with no function, which throws
      // "The listener argument must be of type Function". Remove the handler
      // registered in requestdata() by reference, and clear the ref so that a
      // remount (including React 18 StrictMode's double-invoke) re-attaches it.
      if (messageHandlerRef.current) {
        props.mqttClient.removeListener("message", messageHandlerRef.current);
        messageHandlerRef.current = null;
      }
    },
    []
  );

  //<hr className="hr" />
  //id={list.replace(" ", "_") + "_Loading"}
  if (state.How_to_display_json == "") {
    return (
      <div className="col">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading {props.viewId.replace("_", " ")} ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else {
    return processHowToDisplay(state.How_to_display_json);
  }
};
export default ParametersView;
